module.exports = __webpack_public_path__ + "4e786d796e22224f8ed719c81fa96931.png";